import React from "react";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import PasswordIcon from "@mui/icons-material/Password";

const Banner = () => {
  return (
    <Box marginTop={{ xs: "20%", sm: "5%" }}>
      <Box alignItems={"center"} width={"100%"}>
        <Typography
          variant={"h3"}
          fontWeight={700}
          textAlign={"center"}
          color={"#fff"}
        >
          Our Impact
        </Typography>
        <Stack
          spacing={2}
          width={{ xs: "70%", sm: "25%" }}
          paddingTop={{ xs: "5%", sm: "1%" }}
        >
          <Breadcrumbs
            separator={
              <PasswordIcon
                fontSize="medium"
                sx={{
                  color: "#fff",
                }}
              />
            }
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/"
              sx={{
                color: "#fff",
                fontSize: "18px",
                "&:hover": { color: "#9DCC49" },
              }}
            >
              Home
            </Link>
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/our-impact"
              sx={{
                color: "#9DCC49",
                fontSize: "18px",
                "&:hover": { color: "#fff" },
              }}
            >
              Our Impact
            </Link>
          </Breadcrumbs>
        </Stack>
      </Box>
    </Box>
  );
};

export default Banner;
